import React, { useState, useEffect } from "react";
import { Link, useLocation } from "react-router-dom";

export default function HeaderKnowledge({ refToMenu }) {
  const location = useLocation();
  const [activeLink, setActiveLink] = useState("");

  useEffect(() => {
    // Set active link based on current pathname
    if (location.pathname === "/knowledge") {
      setActiveLink("/knowledge");
    } else if (location.pathname.startsWith("/knowledge/AngularConcepts")) {
      setActiveLink("/knowledge/AngularConcepts");
    } else if (location.pathname.startsWith("/knowledge/UnitTesting")) {
      setActiveLink("/knowledge/UnitTesting");
    }
  }, [location.pathname]); // Runs when pathname changes


  useEffect(() => {
    if (refToMenu?.current) {
      refToMenu.current.setState({ isActiveIndex: activeLink });
    }
  }, [activeLink, refToMenu]);

  return (
    <nav className="flex-group flex-start flex-nowrap">
      <Link className="black" to="/">Home</Link>
      <Link
        className={activeLink === "/knowledge" ? "active" : ""}
        to="/knowledge"
        onClick={() => setActiveLink("/knowledge")}
      >
        Experience
      </Link>
      <Link
        className={activeLink === "/knowledge/ProjectWalkthrough" ? "active" : ""}
        to="/knowledge/ProjectWalkthrough"
        onClick={() => setActiveLink("/knowledge/ProjectWalkthrough")}
      >
        Project Walkthrough
      </Link>
      <div className="divider"></div>
      <Link
        className={activeLink === "/knowledge/AngularConcepts" ? "active" : ""}
        to="/knowledge/AngularConcepts"
        onClick={() => setActiveLink("/knowledge/AngularConcepts")}
      >
        Angular Concepts
      </Link>
      <Link
        className={activeLink === "/knowledge/UnitTesting" ? "active" : ""}
        to="/knowledge/UnitTesting"
        onClick={() => setActiveLink("/knowledge/UnitTesting")}
      >
        Unit Testing
      </Link>
      <div className="divider"></div>
      <Link
        className={activeLink === "/knowledge/ReactConcepts" ? "active" : ""}
        to="/knowledge/ReactConcepts"
        onClick={() => setActiveLink("/knowledge/ReactConcepts")}
      >
        React Concepts
      </Link>
      <Link
        className={activeLink === "/knowledge/NextJSConcepts" ? "active" : ""}
        to="/knowledge/NextJSConcepts"
        onClick={() => setActiveLink("/knowledge/NextJSConcepts")}
      >
        NextJS Concepts
      </Link>
      <div className="divider"></div>
      <Link
        className={activeLink === "/knowledge/VueConcepts" ? "active" : ""}
        to="/knowledge/VueConcepts"
        onClick={() => setActiveLink("/knowledge/VueConcepts")}
      >
        Vue Concepts
      </Link>
    </nav>
  );
}
